var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.HorizontalMenu = new Class({
    Extends: OCS.WxBriefing.Classes.MenuObj,
    underlay: null,
    options: {
        menu_class_name: "secondary_menu",
        element_class_name: "horizontal_menu_container"
    },
    initialize: function (element, ops) {
        if (element) {
            var self = element.retrieve('menu_obj');
            if (self) {
                return self;
            }
        }
        this.parent(element, ops);
        if (this.element && this.options.container) {
            this.element.inject(this.options.container);
        }
        this.underlay = new OCS.WxBriefing.Classes.MenuUnderlay();
    },
    get_menu_element_obj: function (li) {
        return new OCS.WxBriefing.Classes.VerticalMenu(li, {container: this.element});
    }
});
OCS.Bootstrap.addEvent(OCS.Bootstrap.event_names.loading_phase_completed, function () {
    if (OCS.device.mobile) {
        OCS.WxBriefing.Classes.HorizontalMenu.implement(OCS.WxBriefing.Interfaces.MobileVerticalMenu);
    } else {
        OCS.WxBriefing.Classes.HorizontalMenu.implement(OCS.WxBriefing.Interfaces.DesktopHorizontalMenu);
    }
});


